import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';

const ParticleBackground = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Set up Three.js scene
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0x000000, 0); // Set background color and transparency
    containerRef.current.appendChild(renderer.domElement);

    // Create particles
    const particleCount = 800; // Adjust the number of particles
    const particleSize = 0.3; // Adjust the size of the particles
    const particleGeometry = new THREE.SphereGeometry(particleSize, 32, 32); // Adjust the details of the sphere
    const particleMaterial = new THREE.MeshBasicMaterial({
      color: 0xffffff, // Adjust the color of the particles
    });

    for (let i = 0; i < particleCount; i++) {
      const particle = new THREE.Mesh(particleGeometry, particleMaterial);

      particle.position.x = Math.random() * 800 - 400;
      particle.position.y = Math.random() * 800 - 400;
      particle.position.z = Math.random() * 800 - 400;

      scene.add(particle);
    }

    // Set camera position
    camera.position.z = 100;

    // Animation loop
    const animate = () => {
      requestAnimationFrame(animate);
      scene.rotation.x += 0.001;
      scene.rotation.y += 0.001;
      renderer.render(scene, camera);
    };

    animate();

    // Clean up on unmount
    return () => {
      renderer.dispose();
      containerRef.current.removeChild(renderer.domElement);
    };
  }, []);

  return <div className="fixed inset-0" ref={containerRef} />;
};

export default ParticleBackground;
